import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import {SuggestionListsService} from '../../../../services/suggestion-lists.service';
import {Router} from '@angular/router';
import { AdminService } from '../../../../../../../services/admin.service';

@Component({
  selector: 'app-cancel-popup',
  templateUrl: './cancel-popup.component.html',
  styleUrls: ['./cancel-popup.component.css']
})
export class CancelPopupComponent implements OnInit {
  slList: any;
  notifyID: string;

  constructor(
    public activeModal: NgbActiveModal,
    private router: Router,
    public suggestionListsService: SuggestionListsService,
    private adminService: AdminService
  ) { }

  ngOnInit() {
  }

  setSL(sl, notifyID) {
    this.slList = sl;
    this.notifyID = notifyID;
  }

  markNotify(itemId) {
    const sendingParams = {
      id: itemId,
      notificationCategory: "SUGGESTION"
    };
    this.adminService.notifyIsView(sendingParams).subscribe(
      (response: any) => {},
      () => {
      }
    );
  }

  submit() {
    this.suggestionListsService.cancelPostponementSL(this.slList.id).subscribe(
      (res: any) => {
        if (res.status === 200) {
          if(this.router.url.includes('ex-suggestion-expired')) {
            this.markNotify(this.notifyID);
            this.router.navigate(['/ex-notifications']);
            this.activeModal.dismiss('Cross click');
          } else {
            this.router.navigate(['/dashboard/my-suggestion-lists/my-lists']);
            this.activeModal.dismiss('Cross click');
          }
      }
    },
    () => {}
  );
} 
}



// WEBPACK FOOTER //
// C:/work/new2/internal-frontend/src/app/content-page/common/suggestion-lists/components/view-suggestion-list/popups/cancel-popup/cancel-popup.component.ts